import React, { useEffect } from "react";
import "./index.m.css";
import { SUBSCRIBE_PAGE_TEXT } from "../../../../constants";
import Whatsapp from "../../../atoms/social-media-icons/Whatsapp";
import Mail from "../../../atoms/social-media-icons/Mail";
import { isSubscriptionActive } from "../utils/subscription-state";
import { SpinnerIcon } from "../onboard-modal/icons";

export const DowngradeModal = ({ onClose, onConfirm, isLoading, userSubscriptions }) => {
  const active = userSubscriptions.find(isSubscriptionActive);
  const endDate = active ? new Date(active.end_timestamp).toLocaleDateString("en-IN", { day: "numeric", month: "long", year: "numeric" }) : "";
  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "";
    };
  }, []);

  return (
    <div styleName="overlay" onClick={onClose}>
      <div styleName="popupContainer" onClick={(e) => e.stopPropagation()}>
        <h2 styleName="title">Plan Change Requested</h2>

        <p styleName="message">Your plan change request has been registered, and as per our policy, we will be able to change your plan once your current plan expires. Your current plan will continue to stay active till {endDate}.</p>

        <p styleName="message">In case of any further queries, you may reach out to us:</p>

        <div styleName="contactsWrapper">
          <a
            href="#"
            onClick={(e) => {
              e.preventDefault();
              window.open("https://api.whatsapp.com/send/?phone=919035267305&text=Hi%2C%20I%20need%20assistance%20with%20my%20Deccan%20Herald%20Premium%20Subscription.%20Could%20you%20please%20help%20me%3F&type=phone_number&app_absent=0", "_blank", "noopener,noreferrer");
            }}
            styleName="whatsappButton"
          >
            <Whatsapp width={18} height={18} color="#25D366" />
            <span styleName="whatsappText">+91 9035267305</span>
          </a>

          <a
            href="#"
            onClick={(e) => {
              e.preventDefault();
              window.open("https://mail.google.com/mail/?view=cm&fs=1&to=support@deccanherald.com&su=Support%20Required%20for%20DH%20subscription&body=Hi%2C%20I%20need%20assistance%20with%20my%20Deccan%20Herald%20Premium%20Subscription.%20Could%20you%20please%20help%20me%3F", "_blank", "noopener,noreferrer");
            }}
            styleName="mailButton"
          >
            <Mail width={16} height={12} color="#000" />
            <span styleName="mailText">support@deccanherald.com</span>
          </a>

          <div>
            <p styleName="workingHoursLabel">Working hours</p>
            <p styleName="workingHoursTime">Mon - Fri : 10:00 AM to 6:00 PM</p>
          </div>
        </div>

        <button styleName="actionButton" onClick={onConfirm} disabled={isLoading}>
          {isLoading ? <SpinnerIcon styleName="spinner" /> : SUBSCRIBE_PAGE_TEXT.DOWNGRADE_POPUP_BTN}
        </button>
      </div>
    </div>
  );
};
